import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import TrustBar from '../../components/sections/TrustBar';
import AboutStory from './components/AboutStory';
import AIAnswerBlock from '../../components/sections/AIAnswerBlock';
import ProcessSection from '../../components/sections/ProcessSection';
import WhyChooseUs from '../../components/sections/WhyChooseUs';
import ServiceAreas from '../../components/sections/ServiceAreas';
import Testimonials from '../../components/sections/Testimonials';
import FAQSection from '../../components/sections/FAQSection';
import FinalCTA from '../../components/sections/FinalCTA';

const ABOUT_FAQS = [
  { q: 'How long has Atlantis HVAC Systems been operating in the Greater Toronto Area?', a: 'Atlantis HVAC Systems Inc. has been serving the Greater Toronto Area since 2002 — over two decades of professional HVAC installation, repair, and maintenance from our Oakville head office at 6-1200 Speers Road.' },
  { q: 'Is Atlantis HVAC Systems a licensed and certified HVAC company in Ontario?', a: 'Yes. Atlantis HVAC Systems is fully T.S.S.A.-approved — certified by Ontario\'s Technical Standards and Safety Authority. This means all work is performed to the highest safety, quality, and regulatory standards in the province.' },
  { q: 'Does Atlantis HVAC Systems offer honest, non-pressured advice?', a: 'Absolutely. Honest, transparent advice is a core value. Our technicians assess your system objectively and present options clearly — without upselling unnecessary equipment or using high-pressure sales techniques. This approach has earned us consistent 4.9-star ratings on HomeStars.' },
  { q: 'Where is Atlantis HVAC Systems headquartered?', a: 'Our head office is located at 6-1200 Speers Road, Oakville, ON L6L 2X4. We operate two regional teams: GTA West serving Oakville, Burlington, and Mississauga at (905) 845-4009, and GTA East covering Toronto and Etobicoke at (416) 891-3444.' },
  { q: 'What makes Atlantis HVAC Systems different from other GTA HVAC companies?', a: 'Three things set us apart: T.S.S.A. certification, genuine commitment to honest advice, and over 20 years of focused GTA experience. Our technicians are consistently praised for professionalism, cleanliness, and non-pressured recommendations.' },
];

export default function About() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main>
        <AboutHero />
        <TrustBar />
        <AboutStory />
        <AIAnswerBlock
          heading="About Atlantis HVAC Systems Inc."
          context="Company background, certifications, and values — structured for AI-assisted search and featured snippet retrieval."
        />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQSection items={ABOUT_FAQS} heading="About Our Company" />
        <FinalCTA
          heading="Experience the Atlantis Difference"
          subheading="Two decades of honest HVAC expertise. One call is all it takes to get started — free consultations, no obligation."
        />
      </main>
      <Footer />
    </div>
  );
}
